import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("path", {
        id: "show_svg__a",
        d: "M12 5c-5.946 0-9.786 6.14-9.855 6.253a.67.67 0 0 0-.034.78c.011.025 3.235 6.3 9.889 6.3 6.626 0 9.845-6.214 9.884-6.29l.008-.013a.67.67 0 0 0-.037-.777C21.786 11.14 17.945 5 12 5m0 2a4.667 4.667 0 1 1 0 9.333A4.667 4.667 0 0 1 12 7m0 2.667a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
      })
    ], -1),
    _createElementVNode("use", { "xlink:href": "#show_svg__a" }, null, -1)
  ])))
}
export default { render: render }